const project = {
  slug: "lifesync-ai",
  title: "LifeSync AI - Personal Productivity & Wellbeing App",
  oneLiner:
    "Cross-platform Flutter app combining daily planning, habit tracking, and AI-powered wellbeing suggestions.",
  role: ["Mobile App Developer", "Full-stack Developer"],
  category: ["App Development", "AI/ML"],
  clientOrOrg: "Personal Project",
  timeframe: { start: "2026-07", end: "2026-08", status: "Shipped" },
  domain: ["Productivity", "Health & Wellbeing", "AI"],
  tech: ["Flutter", "Dart", "Firebase"],
  links: {},
  gallery: [
    {
      src: "/assets/lifesync-ai/lifesync-ai.png",
      alt: "LifeSync AI - Flutter app showing dashboard, planner, and wellbeing tracking screens"
    }
  ],
  impact: [
    "Combined daily planning, habit tracking, wellbeing monitoring, insights, and AI-powered suggestions in a single application.",
    "Helped users build healthier routines by turning logged activities into personalised, contextual recommendations.",
    "Gave users visibility into water intake, sleep, mood, activity, and task completion through daily and weekly insights.",
    "Designed a simple, accessible mobile UX focused on quick data entry and actionable recommendations.",
    "Implemented privacy-focused handling of personal task and wellbeing data using Firebase."
  ],
  responsibilities: [
    "Designed and developed the mobile application with Flutter/Dart, building reusable UI components for dashboards, cards, forms, trackers, navigation, and onboarding across the Dashboard, Planner, Health, Insights, Smart Suggestions, and Profile sections.",
    "Integrated Firebase for authentication and cloud data storage, with user-specific storage and aggregation for tasks, water intake, sleep, mood, activity, and preferences.",
    "Designed the recommendation logic that combines recent sleep, water intake, mood, activity, pending tasks, time of day, and weather into contextual suggestions.",
    "Implemented task reminder notifications with permission handling, background reminder support, and diagnostics for OS permissions, battery optimisation, and exact alarms.",
    "Built the onboarding flow, light/dark/system theming, and email verification/password recovery flows."
  ],
  features: [
    "AI Smart Suggestions - personalised, context-aware recommendations (e.g. hydration reminders, low-sleep workout adjustments, busy-day task prioritisation)",
    "Smart Planner - create, schedule, and remind tasks, with daily completion tracking",
    "Wellbeing Tracker - quick logging of water intake, sleep, mood, steps/activity, and workouts",
    "Personal Insights - weekly visualisations for water, sleep, mood, tasks, and habit consistency",
    "Weather-Aware Recommendations - suggestions adapted to local weather conditions",
    "Reminder & Notification System - task reminders, background notifications, exact alarms, and battery-optimisation diagnostics",
    "Account & Privacy - email/password auth with verification and reset, profile management, and user-specific data isolation"
  ],
  architecture: [
    "Flutter mobile app (Dart) with a modular screen structure: Dashboard, Planner, Health, Insights, Smart Suggestions, Profile",
    "Firebase Authentication + cloud data storage for user-specific tasks and wellbeing logs",
    "On-device recommendation engine combining wellbeing signals, historical patterns, time of day, and weather context",
    "Local notification scheduling with background reminders and OS-level permission/battery diagnostics"
  ],
  seo: {
    title: "LifeSync AI - Flutter Wellbeing & Productivity App Case Study",
    description:
      "Built a Flutter mobile app combining task planning, habit tracking, and AI-powered wellbeing suggestions, with Firebase-backed data storage and privacy-focused user isolation."
  },
  cover: "/assets/lifesync-ai/lifesync-ai.png"
};

export default project;
